import { useContext, useState } from "react";
import { TextsContext } from "context/textsContext";
import { transformData } from "components/utils/RequestQuoter.util";
import { quoter } from "api/feature/quoterApi";
import { useQuoteFormContext } from "./useQuoteFormContext";

// Manual retry for the "Recalculate" button next to CalculationErrorBadge.
// Works for both the regular quoter (ApiContext) and the Favorite Plan form
// (MyFavoritePlanFormContext) via useQuoteFormContext, which resolves the
// right provider from the current route.
export const useRecalculateQuote = () => {
    const { contextState, addCalculation, addCalculationError } = useQuoteFormContext();
    const { getCurrentLanguage } = useContext(TextsContext);
    const [isRecalculating, setIsRecalculating] = useState(false);

    const recalculate = async () => {
        setIsRecalculating(true);

        try {
            const reqQuoter = transformData(contextState, getCurrentLanguage(), null);
            const response = await quoter(reqQuoter);

            if (response && response !== undefined && response?.data !== null) {
                addCalculation(response);
            } else {
                addCalculationError();
            }
        } catch (error) {
            console.error("Error recalculating quote:", error);
            addCalculationError();
        } finally {
            setIsRecalculating(false);
        }
    };

    return { recalculate, isRecalculating };
};
